//DnD helpers:
import Droppable from "../Droppable"
import {
  horizontalListSortingStrategy,
  SortableContext,
} from "@dnd-kit/sortable"

//FormulaBuilder components
import RenderFormula from "./RenderFormula/RenderFormula"
import RenderFormulaNewItem from "./RenderFormula/RenderFormulaNewItem"

//PrimeReact
import { Divider } from "primereact/divider"
import { Button } from "primereact/button"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import managementStyles from "../../../../../styles/assessments/ManagementForm.module.css"
import { classNames } from "primereact/utils"

export default function FormulaBuilderForm({
  isDragging,
  isMatrix,
  draggingType,
  formulas,
  draggingNewFormulaOrder,
  overConnectorId,
  defaultOperator,
  onApplyToAllMatrixQuestions,
}) {
  return (
    <div className={myStyles.BuilderContainer}>
      <ConfirmDialog />
      <Droppable id={"FormulaBuilderForm"}>
        <div className={`${myStyles.formLayout}  `}>
          <div className={myStyles.formLayoutHeader}>
            <div className={myStyles.formHeader}>Builder</div>
            {isMatrix && onApplyToAllMatrixQuestions && (
              <Button
                className={classNames(
                  managementStyles.button,
                  myStyles.formHeaderButton
                )}
                type="button"
                onClick={() => {
                  confirmDialog({
                    message:
                      "Are you sure you want to apply this formula to all of the matrix questions?",
                    header: "Confirmation",
                    icon: "pi pi-exclamation-triangle",
                    defaultFocus: "accept",
                    accept: () => {
                      onApplyToAllMatrixQuestions()
                    },
                    reject: () => {},
                  })
                }}
                label="Apply to all matrix questions"
              />
            )}

            <Divider className={myStyles.formDivider} />
          </div>
          <div
            className={`${myStyles.formLayoutBody} ${
              isDragging ? myStyles.formActiveDroppable : ""
            }`}
          >
            <div className={myStyles.formLayoutBodyContainer}>
              <SortableContext
                items={formulas.map((formula) => formula.id)}
                strategy={horizontalListSortingStrategy}
              >
                {formulas.map((formula, index) => (
                  <RenderFormula
                    formulaOrder={formula}
                    renderAsDragging={
                      draggingNewFormulaOrder?.id === formula.id
                    }
                    key={formula.id}
                    hideConnector={index === 0}
                    overConnectorId={overConnectorId}
                  />
                ))}
              </SortableContext>

              <RenderFormulaNewItem
                hasFormulas={formulas?.length > 0}
                defaultOperator={defaultOperator}
                isDragging={isDragging}
                isDraggingOperator={
                  draggingType === "connector" || draggingType === "operator"
                }
              />
            </div>
          </div>
        </div>
      </Droppable>
    </div>
  )
}
